import { TaskStatus } from 'shared/enums/task-status.enum';

export const STATUSES: { label: string; value: TaskStatus }[] = [
  { label: 'Pending', value: TaskStatus.PENDING },
  { label: 'Working', value: TaskStatus.WORKING },
  { label: 'Done', value: TaskStatus.COMPLETED },
];

export const TASKS_STORAGE_KEYS = {
  TASKS_FILTERS: 'tasks-filters',
};
